import * as yup from 'yup';

export const TermoMAISchema = yup.object({
  solicitacao: yup.bool().oneOf([true], 'Atenção, Clique em Opção RCM'),
});

export const TermoMAIInitialValues = {
  solicitacao: false,
};
